import * as React from 'react'
import * as PropTypes from 'prop-types'
import { Rule } from 'glamor'

import { useTheme } from '../../theme'

import { Button } from '../button'
import { ChevronIcon } from '../chevron-icon'

interface IExpandButtonProps {
  onClick?: () => void
  expanded?: boolean
  outline?: boolean
  flush?: boolean
  style?: Rule
  children?: React.ReactNode
  variant?: 'link' | 'clear'
}

export function ExpandButton({ expanded, onClick, outline, style, children, flush, variant }: IExpandButtonProps) {
  const theme = useTheme()

  const styles = {
    expandButton: {
      base: {
        width: '20px',
      },
      outline: {
        background: 'none',
        border: '1px solid #D9DCDE',
        width: theme.settings.spacing.xLarge,
        height: theme.settings.spacing.xLarge,
        borderRadius: theme.settings.spacing.xLarge,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      children: {
        paddingLeft: theme.settings.spacing.xSmall,
        width: 'auto',
      },
    },
  }

  return (
    <Button
      flush={flush}
      onClick={onClick}
      size="xSmall"
      style={[
        styles.expandButton.base,
        children && styles.expandButton.children,
        outline && styles.expandButton.outline,
        theme.settings.focusStyles,
        style,
      ]}
      type="button"
      variant={variant}
    >
      {children}
      <ChevronIcon
        color={variant === 'link' ? theme.colors.accents.primary : theme.colors.accents.secondary}
        direction={expanded ? 'up' : 'down'}
      />
    </Button>
  )
}

ExpandButton.propTypes = {
  onClick: PropTypes.func,
  expanded: PropTypes.bool,
  outline: PropTypes.bool,
  flush: PropTypes.bool,
  style: PropTypes.object,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['link', 'clear']),
}

ExpandButton.defaultProps = {
  variant: 'clear',
}

ExpandButton.VARIANTS = ['link', 'clear']
